import { render, staticRenderFns } from "./SlotColorPicker.vue?vue&type=template&id=26247262&scoped=true&"
import script from "./SlotColorPicker.vue?vue&type=script&lang=js&"
export * from "./SlotColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./SlotColorPicker.vue?vue&type=style&index=0&id=26247262&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26247262",
  null
  
)

export default component.exports